module.exports = __webpack_public_path__ + "static/img/our-customers-data-center-hero.585706b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-customers/our-customers-data-center-hero.jpg
// module id = 2EOF
// module chunks = 0